import React,{Component} from "react";
import Cookies from "universal-cookie";
//import NumberFormat from 'react-number-format';
const axios = require("axios");
const generator= require("generate-password");
const cookies=new Cookies();
class forgotPWD extends Component{
    constructor(props){
        super(props);
           this.state={input:{},errors:{},error:'',errorcss:"text-danger",bdisabled:false};
           this.handleChange = this.handleChange.bind(this);
           this.handlechangepwd = this.handlechangepwd.bind(this);

        }
	/////CNIC Patteren
    handleChange(event) {
        let input=this.state.input;
        input[event.target.name]=event.target.value;
        this.setState({input});
        
    }

    handlechangepwd = (event)=>{
        document.body.classList.add('busy-cursor');
        event.preventDefault();
        let password = generator.generate({
        length: 6,
         numbers: true
        });
        let input=this.state.input;
        input["password"]=password;
        this.setState({input});
//        alert(this.state.input["password"]);
//        alert(this.state.input["email"]);
        
        console.log(this.state.input);
      //  this.props.history.push({pathname:'/Success',state: { msg1: "Temporary password has been sent to your email address.",msg2:"Proceed to sign in and reset password." }});

        if(this.validate()){
            this.setState({bdisabled:true});
           axios({
               method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/forgotpwd/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
                })

                .then((response)=> {
                console.log(response.data);
                
                if(response.data === "2")
                { 
                    document.body.style.cursor='default';
                    this.setState({bdisabled:true});                    
                    this.props.history.push({pathname:'/success',state: { msg1: "Temporary password has been sent to your email address.",msg2:"Proceed to sign in." }});
                }
                else if(response.data === "0")
                {
                    this.setState({errorcss: "div-change",error:'Invalid employee code',bdisabled:false});
                    document.body.style.cursor='default';

                }

                else if(response.data === "4")
                {
                    this.setState({errorcss: "div-change",error:'Email address is not registered',bdisabled:false});
                    document.body.style.cursor='default';

                }

                else if(response.data === "3")
                {
                    this.setState({errorcss: "div-change",error:'Error is in sending email, please try later.',bdisabled:false});
                    document.body.style.cursor='default';

                }
                else
                {
                    this.setState({errorcss: "div-change",error:'There might be a connection error.',bdisabled:false});
                    document.body.style.cursor='default';
                }
                })
                .catch((response)=> {
                    //handle error
                    this.setState({error:response.error,bdisabled:false});
                    document.body.style.cursor='default';
                });            
    }}
  
    
    validate(){
        let input = this.state.input;
        let errors = {};
        let isValid = true;
       //For CNIC
        /*if (!input["cnic"]) {
          isValid = false;
          errors["cnic"] = "Please enter valid CNIC.";
        }
        if (typeof input["cnic"] !== "undefined") {   
            let ccnic = input["cnic"];
            ccnic= ccnic.replace(/ /gm, '');
    
            if (ccnic.length < 15) 
          {
            isValid = false;
            errors["cnic"] = "Please enter valid 13 digits CNIC.";
          }
        }*/
        //For email
        if (!input["email"]) {
            isValid = false;
            errors["email"] = "Please enter your email Address.";
          }
      
          if (typeof input["email"] !== "undefined") {
              
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(input["email"])) {
              isValid = false;
              errors["email"] = "Please enter valid email address.";
            }
          }                
        //For Employee code
        if(!input["code"])
        {
            isValid=false;
            errors["code"]="Please enter employee code.";
        }
        if(typeof input["code"] !== "undefined")
        {
            if(input["code"].length < 6)
            {   isValid=false;
                errors["code"]="Please enter valid emplyee code";
            }
        }
        
        //For password
/*        if(!input["ipassword"])
        {
            isValid=false;
            errors["ipassword"]="Please enter password to set.";
        }
        if(typeof input["ipassword"] !== "undefined")
        {
            if(input["ipassword"].length < 8 && input["ipassword"].length > 20)
            {   isValid=false;
                errors["ipassword"]="Password should be of min 8, max 20 characters long.";
            }
        }
        //For Confirm password
        if(!input["cpassword"]){
            isValid=false;
            errors["cpassword"]="Please enter password to confirm.";
        }
        if(typeof input["cpassword"] !== "undefined"){
            if(input["cpassword"].length < 8 && input["cpassword"].length > 20)
                {
                    isValid=false;
                    errors["cpassword"]="Password should be of min 8, max 20 characters long.";
                }
                if(input["cpassword"] !== input["ipassword"] )
                {
                    isValid=false;
                    errors["cpassword"]="Confirm password does not match.";
                }

        }
*/
        this.setState({errors: errors});
        return isValid;
    }        
    render(){
        
        return(
        <div className="auth-wrapper">
        <div className="auth-inner" id="inn" >

            <form>
                
                {<h3>Forget Password</h3>}
{/*                <div id="error" className="text-danger">{this.state.error}</div>

                <div className="form-group row">
                    <label>National Identity Card (CNIC).</label>
                    <NumberFormat format="#####-#######-#"  id="cnic" name="cnic" className="form-control" required size="14" onBlur={this.handleChange} placeholder="Enter 15 digits CNIC" />

                    <input type="text" id="cnic" name="cnic" className="form-control"  maxLength="15" placeholder="Enter 15 digits CNIC (with -)" onBlur={this.handleChange} value={this.state.input.cnic}></input>
                    <small id="passwordHelp" className="text-danger">{this.state.errors.cnic}</small>
        </div>*/}
                <div className="form-group row">
                    <label>Employee code.</label>
                    <input type="text" name="code" id="code" size="8" className="form-control" placeholder="Enter employee code" onBlur={this.handleChange}/>
                    <small id="passwordHelp" className="text-danger">{this.state.errors.code}</small>

                </div>
                <div className="form-group row">
                    <label>Registered email address </label>
                    <input type="email" name="email" id="email" className="form-control" placeholder="Enter registered email" onBlur={this.handleChange}/>
                    <small id="passwordHelp" className="text-danger">{this.state.errors.email}</small>
                </div>

                <div className={this.state.errorcss}>{this.state.error}</div>
                <button type="submit" className="btn button-primary btn-block" onClick={this.handlechangepwd} >Reset Password</button>
                <br></br>               

               {/* <p className="forgot-password text-right">Forgot <a href="#">Password ?</a></p>*/}
    </form>
    </div>                

    </div>
        )
    }

}
export default forgotPWD